import { AxiosInstance } from 'axios';
import * as PrePaymentReportService from './services';

export type PrePaymentReportServiceType = ReturnType<typeof PrePaymentReportService.exportPDF>;

export const initPrePaymentReportService = (axios: AxiosInstance): PrePaymentReportServiceType =>
  PrePaymentReportService.exportPDF(axios);
